import { Button } from "materia"
import { useTranslation } from "react-i18next"
import type { ConnState } from "../../types"
import s from "./ConnectionBanner.module.scss"

type ConnectionBannerProps = {
  connState: ConnState
  onReconnect: () => void
}

/**
 * Shown only on the terminal `failed` state — the one the runtime has stopped
 * retrying on its own. The transient states (reconnecting, connecting) recover
 * by themselves and say so through the composer note, so a banner for them would
 * only flicker; here there is nothing to wait for but the reader's own retry.
 */
export function ConnectionBanner({
  connState,
  onReconnect,
}: ConnectionBannerProps) {
  const { t } = useTranslation()

  if (connState !== "failed") return null

  return (
    <div className={s.banner} role="alert">
      <span className={s.banner__text}>{t("chat.CONN_FAILED")}</span>
      <Button size="medium" onClick={onReconnect}>
        {t("chat.CONN_RECONNECT")}
      </Button>
    </div>
  )
}
